import React, { FC } from 'react';
import styled from 'styled-components';
import { Profile } from '../index';
import { ProfileFormData } from './ProfileForm';
import { ProfileSettingsInfoFormCard } from './ProfileSettingsInfoFormCard';

interface Props {
  onSubmit: (values: ProfileFormData) => void;
  profile: Profile;
}

const Styles = styled.div``;

export const ProfileSettingsInfo: FC<Props> = ({ onSubmit, profile }): JSX.Element => {
  return (
    <Styles>
      <div className="info-settings-card">
        <ProfileSettingsInfoFormCard onSubmit={onSubmit} profile={profile} />
      </div>
    </Styles>
  );
};
